import React, { Fragment } from 'react';
import ReactTable from 'react-table';
import { Field } from 'redux-form';
import {
  Accordion,
  Grid,
  Form,
  Header,
  Icon,
  Button,
  Divider,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { DatePickerCustomButton } from 'Components';
import { DatePickerField } from 'Common/SemanticWrapper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { SiteComponent } from 'Common/SiteComponent';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { AvailableKitchenPrepWorksheetEnum } from 'Common/FieldEnum';
import { SiteTypeEnum } from 'Common/Constants/Enumeration/SiteTypeEnum';

const AvailableKitchenPrepWorksheetComponent = props => {
  const {
    activeIndexForFilter,
    handleClick,
    onChangeOfFromDT,
    onChangeOfToDT,
    fromDateMax,
    toDateMin,
    onDropDownChange,
    clearFilters,
    reactTableRef,
    columns,
    setExpandedState,
    expanded,
    availableKitchenData,
    availableKitchenDataLoading,
    sorted,
    onSortedChange,
    filtered,
    onFilteredChange,
    page,
    onPageChange,
    onPageSizeChange,
  } = props;
  return (
    <Fragment>
      <Form>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Accordion fluid styled>
                <Accordion.Title
                  active={!activeIndexForFilter}
                  onClick={handleClick}
                  index={0}
                  option={0}
                >
                  <Icon name="dropdown" />
                  <span className="text-orange">Filter By</span>
                </Accordion.Title>
                <Accordion.Content active={!activeIndexForFilter}>
                  <Grid>
                    <Grid.Row columns={2}>
                      <Grid.Column width={8}>
                        <div style={{ paddingTop: 25 }}>
                          <Header as="h4">Delivery Date Range</Header>
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={4}>
                      <Grid.Column width={4}>
                        <Field
                          component={DatePickerField}
                          customInput={<DatePickerCustomButton />}
                          label={'From:'}
                          dateFormat={DATE_FORMAT_FOR_UI}
                          name={AvailableKitchenPrepWorksheetEnum.BeginDT}
                          onChange={onChangeOfFromDT}
                          maxDate={fromDateMax}
                          type={'text'}
                          dropdownMode={'select'}
                        />
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Field
                          component={DatePickerField}
                          customInput={<DatePickerCustomButton />}
                          label={'To:'}
                          dateFormat={DATE_FORMAT_FOR_UI}
                          name={AvailableKitchenPrepWorksheetEnum.EndDT}
                          type={'text'}
                          onChange={onChangeOfToDT}
                          minDate={toDateMin}
                          dropdownMode={'select'}
                        />
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <SiteComponent
                          label={'Kitchen'}
                          name={AvailableKitchenPrepWorksheetEnum.Kitchen}
                          onChange={onDropDownChange}
                          isForm={true}
                          siteMasterTypeIds={[SiteTypeEnum.Kitchen]}
                          style={{ marginBottom: 10 }}
                          checkIsLicensed={false}
                          isAllRequired={false}
                        />
                      </Grid.Column>
                      <Grid.Column
                        floated={'right'}
                        textAlign={'right'}
                        style={{
                          marginTop: 32,
                        }}
                        width={4}
                      >
                        <Button
                          content={'Clear Filters'}
                          onClick={clearFilters}
                          type={'button'}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Accordion.Content>
              </Accordion>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider horizontal />
        <Grid>
          <Grid.Row columns={1} className={'remove-spacing'}>
            <Grid.Column>
              <ReactTable
                ref={reactTableRef}
                defaultPageSize={20}
                minRows={0}
                resizable={false}
                className="-striped -highlight modalGrid"
                defaultFilterMethod={caseInsensitiveFilter}
                data={availableKitchenData}
                columns={columns}
                loading={availableKitchenDataLoading}
                noDatatext={availableKitchenDataLoading ? '' : 'No rows found'}
                hasExpanderColumn={true}
                onExpandedChange={(newExpanded, index, event) => {
                  setExpandedState(newExpanded);
                }}
                expanded={expanded}
                sorted={sorted}
                onSortedChange={onSortedChange}
                filtered={filtered}
                onFilteredChange={onFilteredChange}
                page={page}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                SubComponent={({ original: { KitchenItems } }) => {
                  return (
                    <div style={{ padding: 10 }}>
                      <ReactTable
                        filterable
                        defaultPageSize={KitchenItems.length}
                        minRows={0}
                        showPageSizeOptions={false}
                        defaultFilterMethod={(filter, row) =>
                          String(
                            row[AvailableKitchenPrepWorksheetEnum.DeliveryDate]
                          ) === filter.value
                        }
                        className="-striped -highlight modalGrid no-hover"
                        data={KitchenItems}
                        resizable={false}
                        sortable={false}
                        showPagination={false}
                        menu={false}
                        columns={[
                          {
                            Header: 'Item Code',
                            columns: [
                              {
                                accessor:
                                  AvailableKitchenPrepWorksheetEnum.ItemCode,
                                sortable: true,
                                filterable: false,
                              },
                            ],
                          },
                          {
                            Header: 'Description',
                            columns: [
                              {
                                accessor:
                                  AvailableKitchenPrepWorksheetEnum.Description,
                                sortable: true,
                                filterable: false,
                              },
                            ],
                          },
                          {
                            Header: 'Ordered',
                            columns: [
                              {
                                Header: 'Purchase Qty',
                                headerStyle: { textAlign: 'right' },
                                accessor:
                                  AvailableKitchenPrepWorksheetEnum.OrderedPrimary,
                                className: 'right-align',
                                sortable: true,
                                filterable: false,
                              },
                              {
                                Header: 'Pack Qty',
                                headerStyle: { textAlign: 'right' },
                                accessor:
                                  AvailableKitchenPrepWorksheetEnum.OrderedSecondary,
                                className: 'right-align',
                                sortable: true,
                                filterable: false,
                              },
                            ],
                          },
                          {
                            Header: 'Needed',
                            columns: [
                              {
                                Header: 'Purchase Qty',
                                headerStyle: { textAlign: 'right' },
                                accessor:
                                  AvailableKitchenPrepWorksheetEnum.NeededPrimary,
                                className: 'right-align',
                                sortable: true,
                                filterable: false,
                              },
                              {
                                Header: 'Pack Qty',
                                headerStyle: { textAlign: 'right' },
                                accessor:
                                  AvailableKitchenPrepWorksheetEnum.NeededSecondary,
                                className: 'right-align',
                                sortable: true,
                                filterable: false,
                              },
                            ],
                          },
                          {
                            Header: 'Packaging',
                            columns: [
                              {
                                accessor:
                                  AvailableKitchenPrepWorksheetEnum.Packaging,
                                sortable: true,
                                filterable: false,
                              },
                            ],
                          },
                        ]}
                      />
                    </div>
                  );
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </Fragment>
  );
};

AvailableKitchenPrepWorksheetComponent.propTypes = {
  columns: PropTypes.array.isRequired,
  activeIndexForFilter: PropTypes.number,
  handleClick: PropTypes.func,
  onChangeOfFromDT: PropTypes.func,
  onChangeOfToDT: PropTypes.func,
  fromDateMax: PropTypes.object,
  toDateMin: PropTypes.object,
  onDropDownChange: PropTypes.func,
  clearFilters: PropTypes.func,
  reactTableRef: PropTypes.object,
  setExpandedState: PropTypes.func,
  expanded: PropTypes.array,
  availableKitchenData: PropTypes.array,
  availableKitchenDataLoading: PropTypes.bool,
  sorted: PropTypes.array,
  onSortedChange: PropTypes.func,
  filtered: PropTypes.array,
  onFilteredChange: PropTypes.func,
  page: PropTypes.number,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
};

AvailableKitchenPrepWorksheetComponent.defaultProps = {
  activeIndexForFilter: 0,
  handleClick: () => {},
  onChangeOfFromDT: () => {},
  onChangeOfToDT: () => {},
  fromDateMax: null,
  toDateMin: null,
  onDropDownChange: () => {},
  clearFilters: () => {},
  reactTableRef: null,
  setExpandedState: () => {},
  expanded: [],
  availableKitchenData: [],
  availableKitchenDataLoading: false,
  sorted: [],
  onSortedChange: () => {},
  filtered: [],
  onFilteredChange: () => {},
  page: 0,
  onPageChange: () => {},
  onPageSizeChange: () => {},
};
export default AvailableKitchenPrepWorksheetComponent;



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/components/availableKitchenPrepWorksheet/AvailableKitchenPrepWorksheetComponent.js